

















import { Component, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment';
import EditableComponent from '@/shared/components/EditableComponent.vue';

@Component({
	components: { EditableComponent },
})
export default class TimeSelector extends Vue {
	@Prop() public value: Date;

	public selectedDate: Date = new Date();

	public mounted() {
		this.selectedDate = this.value;
	}

	public get displayDate() {
		return moment(this.selectedDate).format('HH:mm, DD/MM/YYYY');
	}

	public handleDateChange(date: Date) {
		this.selectedDate = date;
		this.emitSelectedDate();
	}

	private emitSelectedDate() {
		this.$emit('input', this.selectedDate);
	}
}
